.picture {
  position: relative;
  width: 100%;
  max-width: 358px;
  height: 420px;
  margin: 0 auto;
}

.disc,
.mascot {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.disc {
  width: 270px;
  height: 270px;
  border: var(--outline);
  border-radius: 999px;
  background: var(--accent-soft);
}

.mascot {
  display: flex;
}

.desktop {
  display: none;
}

.card {
  position: absolute;
  display: flex;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}

.kicker {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ink-3);
}

.week {
  left: 0;
  top: 0;
  width: 212px;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  transform: rotate(-3deg);
}

.days {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
}

/* A day coloured by completeness, as the app's week bar draws it: green
 * complete, yellow partial, white with no entry, dashed for days to come. */
.day {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  padding: 5px 0;
  border: var(--outline);
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
}

.dayName {
  font-size: 10px;
  font-weight: 600;
}

.complete {
  background: var(--done);
  color: var(--accent-ink);
}

.partial {
  background: var(--accent);
  color: var(--accent-ink);
}

.empty {
  background: var(--surface);
}

.future {
  border: 1.5px dashed var(--ink-3);
  opacity: 0.6;
}

.appointment {
  right: 0;
  bottom: 34px;
  width: 190px;
  flex-direction: column;
  gap: 3px;
  padding: 10px 12px;
  transform: rotate(2.5deg);
}

.when {
  font-size: 17px;
  font-weight: 700;
}

.how {
  font-size: 13px;
  color: var(--ink-2);
}

.note {
  left: 8px;
  bottom: 0;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border-radius: 999px;
  background: var(--accent-soft);
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  transform: rotate(-1.5deg);
}

.dot {
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  border: var(--outline);
  border-radius: 999px;
  background: var(--accent);
}

/* The desktop composition is 458px wide: the 360px disc and the cards that
 * overhang it. It is drawn at that width, centred, wherever there is room,
 * so the cards stay beside the mascot rather than drifting to the edges of a
 * wide column. */
@media (min-width: 720px) {
  .picture {
    max-width: 458px;
    height: 500px;
  }

  .disc {
    width: 360px;
    height: 360px;
  }

  .phone {
    display: none;
  }

  .desktop {
    display: flex;
  }

  .week {
    top: 6px;
    width: 250px;
    padding: 12px;
  }

  .appointment {
    bottom: 44px;
    width: 220px;
    padding: 12px 14px;
  }

  .note {
    left: 22px;
    padding: 10px 14px;
  }
}
